import { PotsActionType } from "@/features/user";
import useToast from "@/hooks/useToast";
import { RootState } from "@/store/reducers";
import { useSelector } from "react-redux";

export default function ReportContent({
  type,
  handleReport,
}: {
  type: PotsActionType;
  handleReport: (reasonId: string) => void;
}) {
  const { reportContentReasons } = useSelector(
    (state: RootState) => state.post.postViewData
  );
  const { showConfirmationAlert } = useToast();

  const onReport = (value: string) => {
    showConfirmationAlert(
      `Are you sure you want to report this ${type}?`,
      () => {
        handleReport(value);
      },
      () => {}
    );
  };

  return (
    <>
      {reportContentReasons?.map((item) => (
        <div
          key={item.value}
          className="border-b-2"
          onClick={() => onReport(item.value)}
        >
          <div className="cursor-pointer px-4 py-2 ">{item.text}</div>
        </div>
      ))}
    </>
  );
}
